// auto-generated by bin/genVersion.ts
export const VERSION = '2.13.0';
